<agc-tree-map
  #treeMap
  (treeMapClick)="onClick($event)"
  (treeMapDblClick)="onDblClick($event)"
  (treeMapMouseEnter)="onMouseEnter($event)"
  (treeMapMouseLeave)="onMouseLeave()"
  (treeMapMouseMove)="onMouseMove($event)"
>
</agc-tree-map>
